export class InsertBuilding {
  buildingKeys: string[];
  blockId: string;

  constructor(keys: string[], areaId: string) {
    this.buildingKeys = keys;
    this.blockId = areaId;
  }
}
